<div class="row no-gutters px-3 py-3 mb-3 mb-cart-item">
  <ng-container *ngIf="item">
    <!-- Small, medium and large devices layout -->
    <div class="hidden-xs col-sm-4 col-md-3 px-2 my-lg-auto"
         data-cy="mb-cart-item-left-section">
      <cx-media
        [container]="item.product?.images?.PRIMARY"
        format="product"
        alt="Cart Icon">
      </cx-media>
    </div>

    <div class="hidden-xs col-sm-8 col-md-9 px-2"
         data-cy="mb-cart-item-right-section">
      <div class="row no-gutters">
        <div class="col-9">
          <div class="pb-2 mb-cart-item-code"
               data-cy="mb-cart-item-code">
            <strong [innerHTML]="item.product?.code | safeHtml"></strong>
          </div>
          <div class="pb-2 mb-cart-item-name"
               data-cy="mb-cart-item-name">
              <a class="mb-cart-item-pdp-link" [routerLink]="('/' + item.product?.code)">
                <strong [innerHTML]="item.product?.nameHtml | safeHtml"></strong>
              </a>
            <span *ngIf="item.product?.clinicalReferenceNumber"
                  class="ml-1"
                  [innerHTML]="'(' + item.product?.clinicalReferenceNumber + ')' | safeHtml">
            </span>
          </div>
          <div *ngIf="item.product?.regulatoryStatus" class="mb-cart-item-rstatus"
               data-cy="mb-cart-item-rstatus"
               [innerHTML]="item.product?.regulatoryStatus | safeHtml">
          </div>
        </div>
        <div class="col-3">
          <div class="cart-qty-selector">
            <mb-quantity-counter
              *ngIf="isDisplayedInCartPage"
              [control]="quantityControl"
              [max]="maxItemQuantity"
              [min]="1"
              [isDisplayedInCartPage]="true">
            </mb-quantity-counter>
            <div *ngIf="!isDisplayedInCartPage"
                 class="mt-4 text-right">
              {{quantityControl?.value}} {{ getItemsLabel() | cxTranslate }}
            </div>
          </div>
        </div>
      </div>

      <div class="row no-gutters mt-3 mb-2 mb-cart-item-info"
           data-cy="mb-cart-item-info">
        <div class="col-2 mb-cart-item-keys"
             data-cy="mb-cart-item-keys">
          <div *ngIf="item.product?.size">{{'cartProductLine.size' | cxTranslate}}</div>
          <div *ngIf="item.product?.clone">{{'cartProductLine.clone' | cxTranslate}}</div>
          <div *ngIf="item.orderEntryType === 'PRICE_MIX' || item.orderEntryType === 'PRICE_AVAILABLE'">
            <div *ngIf="item.basePrice?.formattedValue">{{'cartProductLine.price' | cxTranslate}}</div>
            <div *ngIf="!isDisplayedInCartPage && showYourPrice && entry$ | async">{{'submitBox.yourPrice' | cxTranslate}}</div>
          </div>
        </div>
        <div class="col-6 mb-cart-item-values"
             data-cy="mb-cart-item-values">
          <div *ngIf="item.product?.size"><span [innerHTML]="item.product?.size | safeHtml"></span></div>
          <div *ngIf="item.product?.clone"><span [innerHTML]="item.product?.clone | safeHtml"></span></div>
          <div *ngIf="item.orderEntryType === 'PRICE_MIX' || item.orderEntryType === 'PRICE_AVAILABLE'">

            <div *ngIf="isDisplayedInCartPage && item.basePrice?.formattedValue">
              <span [innerHTML]="item.basePrice?.formattedValue | safeHtml"></span>
            </div>

            <div *ngIf="!isDisplayedInCartPage && item.erpBaseListPrice?.formattedValue">
              <span [innerHTML]="item.erpBaseListPrice?.formattedValue | safeHtml"></span>
            </div>

            <div *ngIf="!isDisplayedInCartPage && !item.erpBaseListPrice?.formattedValue && item.basePrice?.formattedValue">
              <span [innerHTML]="item.basePrice?.formattedValue | safeHtml"></span>
            </div>

            <div *ngIf="!isDisplayedInCartPage && showYourPrice && entry$ | async as entry">
              <span [innerHTML]="entry?.erpPriceSingle?.formattedValue | safeHtml"></span>
            </div>
          </div>
        </div>
        <div class="col-4 text-right cart-item-price">
          <div *ngIf="item.orderEntryType === 'PRICE_MIX' || item.orderEntryType === 'PRICE_AVAILABLE'">
            <div *ngIf="isDisplayedInCartPage && item.totalPrice?.formattedValue">
              <span [innerHTML]="item.totalPrice?.formattedValue | safeHtml"></span>
            </div>

            <div *ngIf="!isDisplayedInCartPage && item.erpListPrice?.formattedValue && !showYourPrice">
              <span [innerHTML]="item.erpListPrice?.formattedValue | safeHtml"></span>
            </div>

            <div *ngIf="!isDisplayedInCartPage && !item.erpListPrice?.formattedValue && item.totalPrice?.formattedValue">
              <span [innerHTML]="item.totalPrice?.formattedValue | safeHtml"></span>
            </div>

            <div *ngIf="!isDisplayedInCartPage && showYourPrice && entry$ | async as entry">
              <span [innerHTML]="entry?.erpPrice?.formattedValue | safeHtml"></span>
            </div>
          </div>
          <div *ngIf="item.orderEntryType === 'PRICE_REQUEST'">
            <div class="mb-cart-items-request-price-label" data-cy="mb-cart-item-request-price-label">
              <strong>{{'mbcommon.priceOnRequest' | cxTranslate}}</strong></div>
          </div>
          <div *ngIf="showAddToCartButton && !item.product?.discontinued"
               class="mt-2 mb-cart-item-add-to-cart-button">
            <mb-add-to-cart [addToCartForm]="addToCartForm"
                            [hasPriceOnRequest]="item.orderEntryType === 'PRICE_REQUEST'"
                            [product]="item?.product"
                            [clickSource]="dataAnalyticsClickSource"
                            class="float-right"
                            [productCode]="item?.product?.code">
            </mb-add-to-cart>
          </div>
        </div>
      </div>

      <div class="row no-gutters mb-cart-item-actions"
           data-cy="mb-cart-item-actions">
        <div class="col-6">
          <div *ngIf="item.product?.dataSheets">
            <div *ngIf="item.product?.dataSheets?.entry"
                 data-cy="mb-product-line-mb-data-sheets">
                    <span class="cursor-pointer mb-product-line-data-sheet">
                       <span *ngIf="item.product?.dataSheets?.entry?.length  > 1; else oneDataSheet"
                             (click)="openMultiValueModal(item.product?.dataSheets,'datasheets')">
                              <img src="../../../assets/icons/svg/data-sheet.svg"
                                   class="mr-1 mb-1 mb-cart-item-icons"
                                   alt="Download sheet icon"
                                   title="Data Sheet Icon"
                                   aria-label="Data Sheet"
                                   data-cy="mb-cart-data-sheet-icon"/>
                              <span class="mb-data-sheet-hover">{{'mbcommon.dataSheets' | cxTranslate}}</span>
                       </span>
                        <ng-template #oneDataSheet>
                          <div *ngFor="let dataSheet of item.product?.dataSheets?.entry">
                            <span data-cy="mb-cart-entry-data-sheet"
                                  [innerHTML]="addDataSheetUserManualLink(dataSheet.value, 'mbcommon.dataSheet', true) | async  | safeHtml">
                            </span>
                          </div>
                        </ng-template>
                     </span>
            </div>
          </div>
          <div *ngIf="item.product?.userManuals?.entry"
               class="d-inline-block"
               data-cy="mb-cart-mb-user-manuals">
                   <span class="mb-cart-user-manuals">
                     <span *ngIf="item.product?.userManuals?.entry.length > 1; else oneUserManual"
                           (click)="openMultiValueModal(item.product?.userManuals,'usermanuals')">
                       <img src="../../../assets/icons/svg/data-sheet.svg"
                            class="mr-1 mb-1 mb-cart-item-icons"
                            alt="Download sheet icon"
                            title="Data Sheet Icon"
                            aria-label="Data Sheet"
                            data-cy="mb-cart-user-manual-icon"/>
                        <span class="mb-data-sheet-hover">{{'pdpProductLine.userManuals' | cxTranslate}}</span>
                     </span>
                      <ng-template #oneUserManual>
                         <div *ngFor="let userManual of item.product?.userManuals?.entry">
                           <span data-cy="mb-cart-entry-user-manual"
                                 [innerHTML]="addDataSheetUserManualLink(userManual.value, 'pdpProductLine.userManual', true) | async  | safeHtml">
                            </span>
                         </div>
                      </ng-template>
                   </span>
          </div>
        </div>
        <div *ngIf="isDisplayedInCartPage"
             class="col-6 text-right"
             data-cy="mb-cart-item-delete">
          <span class="cursor-pointer mb-cart-item-delete"
                (click)="removeItem(item)">
            <img src="../../../assets/icons/svg/icon_trash_primary.svg"
                 class="mr-1 mb-1 mb-cart-item-icons"
                 title="Delete item"
                 alt="Delete item icon"
                 aria-label="Delete item icon">
            <span>{{'common.delete'| cxTranslate}}</span>
          </span>
        </div>
      </div>
    </div>
    <!-- End of small, medium and large devices layout -->

    <!-- Extra-small devices layout -->
    <div class="col-12 hidden-sm hidden-md hidden-lg hidden-xl"
         data-cy="mb-cart-item-xs-section-one">
      <div class="row no-gutters">
        <div class="col-2 my-auto">
          <cx-media
            [container]="item.product?.images?.PRIMARY"
            format="product"
            alt="Cart Icon">
          </cx-media>
        </div>
        <div class="col-10 pl-3">
          <div class="pb-2 mb-cart-item-code"><strong [innerHTML]="item.product?.code | safeHtml"></strong></div>
          <div *ngIf="item.product?.regulatoryStatus" class="mb-cart-item-rstatus"
               [innerHTML]="item.product?.regulatoryStatus | safeHtml"></div>
        </div>
      </div>
    </div>

    <div class="col-12 hidden-sm hidden-md hidden-lg hidden-xl mt-2"
         data-cy="mb-cart-item-xs-section-two">
      <div class="pb-2 mb-cart-item-name">
        <a class="mb-cart-item-pdp-link" [routerLink]="('/' + item.product?.code)">
          <strong [innerHTML]="item.product?.nameHtml | safeHtml"></strong>
        </a>
        <span *ngIf="item.product?.clinicalReferenceNumber"
              class="ml-1"
              [innerHTML]="'(' + item.product?.clinicalReferenceNumber + ')' | safeHtml">
        </span>
      </div>
    </div>

    <div class="col-6 hidden-sm hidden-md hidden-lg hidden-xl mb-2 mb-cart-item-keys"
         data-cy="mb-cart-item-xs-section-three">
      <div *ngIf="item.product?.size">{{'cartProductLine.size' | cxTranslate}}</div>
      <div *ngIf="item.product?.clone">{{'cartProductLine.clone' | cxTranslate}}</div>
      <div *ngIf="item.orderEntryType === 'PRICE_MIX' || item.orderEntryType === 'PRICE_AVAILABLE'">
        <div *ngIf="isDisplayedInCartPage && item.basePrice?.formattedValue">{{'cartProductLine.price' | cxTranslate}}</div>
        <div *ngIf="!isDisplayedInCartPage && item.erpBaseListPrice?.formattedValue">{{'cartProductLine.price' | cxTranslate}}</div>
        <div *ngIf="!isDisplayedInCartPage && showYourPrice && entry$ | async">{{'submitBox.yourPrice' | cxTranslate}}</div>
      </div>
    </div>

    <div class="col-6 hidden-sm hidden-md hidden-lg hidden-xl mb-2 text-right mb-cart-item-values"
         data-cy="mb-cart-item-xs-section-four">
      <div *ngIf="item.product?.size"><span [innerHTML]="item.product?.size | safeHtml"></span></div>
      <div *ngIf="item.product?.clone"><span [innerHTML]="item.product?.clone | safeHtml"></span></div>

      <div *ngIf="(item.orderEntryType === 'PRICE_MIX' || item.orderEntryType === 'PRICE_AVAILABLE')">
        <div *ngIf="isDisplayedInCartPage && item.basePrice?.formattedValue">
          <span [innerHTML]="item.basePrice?.formattedValue | safeHtml"></span>
        </div>

        <div *ngIf="!isDisplayedInCartPage && item.erpBaseListPrice?.formattedValue">
          <span [innerHTML]="item.erpBaseListPrice?.formattedValue | safeHtml"></span>
        </div>

        <div *ngIf="!isDisplayedInCartPage && !item.erpBaseListPrice?.formattedValue && item.basePrice?.formattedValue">
          <span [innerHTML]="item.basePrice?.formattedValue | safeHtml"></span>
        </div>

        <div *ngIf="!isDisplayedInCartPage && showYourPrice && entry$ | async as entry">
          <span [innerHTML]="entry?.erpPriceSingle?.formattedValue | safeHtml"></span>
        </div>
      </div>
    </div>

    <div class="col-6 hidden-sm hidden-md hidden-lg hidden-xl mb-2"
         data-cy="mb-cart-item-xs-section-five">
      <div class="cart-qty-selector">
        <mb-quantity-counter
          *ngIf="isDisplayedInCartPage"
          [control]="quantityControl"
          [max]="maxItemQuantity"
          [min]="1"
          [isDisplayedInCartPage]="true">
        </mb-quantity-counter>
        <span *ngIf="!isDisplayedInCartPage"
              class="text-right">
            {{quantityControl?.value}} {{ getItemsLabel() | cxTranslate }}
          </span>
      </div>
    </div>

    <div class="col-6 hidden-sm hidden-md hidden-lg hidden-xl mb-2 text-right cart-item-price"
         data-cy="mb-cart-item-xs-section-six">
      <div *ngIf="item.orderEntryType === 'PRICE_MIX' || item.orderEntryType === 'PRICE_AVAILABLE'">
        <div *ngIf="isDisplayedInCartPage && item.totalPrice?.formattedValue">
          <span [innerHTML]="item.totalPrice?.formattedValue | safeHtml"></span>
        </div>

        <div *ngIf="!isDisplayedInCartPage && item.erpListPrice?.formattedValue && !showYourPrice">
          <span [innerHTML]="item.erpListPrice?.formattedValue | safeHtml"></span>
        </div>

        <div *ngIf="!isDisplayedInCartPage && !item.erpListPrice?.formattedValue && item.totalPrice?.formattedValue">
          <span [innerHTML]="item.totalPrice?.formattedValue | safeHtml"></span>
        </div>

        <div *ngIf="!isDisplayedInCartPage && showYourPrice && entry$ | async as entry">
          <span [innerHTML]="entry?.erpPrice?.formattedValue | safeHtml"></span>
        </div>
      </div>
      <div *ngIf="item.orderEntryType === 'PRICE_REQUEST'">
        <div class="mb-cart-items-request-price-label" data-cy="mb-cart-item-request-price-label">
          <strong>{{'mbcommon.priceOnRequest' | cxTranslate}}</strong></div>
      </div>
    </div>
    <div *ngIf="isDisplayedInCartPage"
         class="col-5 hidden-sm hidden-md hidden-lg hidden-xl mb-cart-item-actions"
         data-cy="mb-cart-item-xs-section-eight">
      <span class="cursor-pointer"
            (click)="removeItem(item)">
        <img src="../../../assets/icons/svg/icon_trash_primary.svg"
             class="mr-1 mb-1 mb-cart-item-icons"
             title="Delete item"
             alt="Delete item icon"
             aria-label="Delete item icon">
        <span>{{'common.delete'| cxTranslate}}</span>
      </span>
    </div>

    <div class="col-7 hidden-sm hidden-md hidden-lg hidden-xl text-right mb-cart-item-actions"
         data-cy="mb-cart-item-xs-section-nine">
      <div *ngIf="item.product?.dataSheets?.entry"
           data-cy="mb-product-line-mb-data-sheets">
                 <span class="cursor-pointer mb-product-line-data-sheet">
                     <span *ngIf="item.product?.dataSheets?.entry?.length  > 1; else oneDataSheet"
                           (click)="openMultiValueModal(item.product?.dataSheets,'datasheets')">
                          <img src="../../../assets/icons/svg/data-sheet.svg"
                               class="mr-1 mb-1 mb-cart-item-icons"
                               alt="Download sheet icon"
                               title="Data Sheet Icon"
                               aria-label="Data Sheet"
                               data-cy="mb-cart-data-sheet-icon"/>
                          <span class="mb-data-sheet-hover">{{'mbcommon.dataSheets' | cxTranslate}}</span>
                     </span>
                     <ng-template #oneDataSheet>
                        <div *ngFor="let dataSheet of item.product?.dataSheets?.entry">
                          <span data-cy="mb-cart-entry-data-sheet-sm"
                                [innerHTML]="addDataSheetUserManualLink(dataSheet.value, 'mbcommon.dataSheet', true) | async  | safeHtml">
                          </span>
                        </div>
                     </ng-template>
                 </span>
      </div>
      <div *ngIf="item.product?.userManuals?.entry"
           class="d-inline-block"
           data-cy="mb-cart-mb-user-manuals">
              <span class="mb-cart-user-manuals">
                     <span *ngIf="item.product?.userManuals?.entry?.length > 1; else oneUserManual"
                           (click)="openMultiValueModal(item.product?.userManuals,'usermanuals')">
                       <img src="../../../assets/icons/svg/data-sheet.svg"
                            class="mr-1 mb-1 mb-cart-item-icons"
                            alt="Download sheet icon"
                            title="Data Sheet Icon"
                            aria-label="Data Sheet"
                            data-cy="mb-cart-user-manual-icon-sm"/>
                       <span class="mb-data-sheet-hover">{{'pdpProductLine.userManuals' | cxTranslate}}</span>
                     </span>
                     <ng-template #oneUserManual>
                         <div *ngFor="let userManual of item.product?.userManuals?.entry">
                           <span data-cy="mb-cart-entry-user-manual-sm"
                                 [innerHTML]="addDataSheetUserManualLink(userManual.value, 'pdpProductLine.userManual', true) | async  | safeHtml">
                           </span>
                         </div>
                     </ng-template>
              </span>
      </div>
    </div>
    <!-- End of extra-small devices layout -->
  </ng-container>
</div>
